var React = require('react');

function Eye (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"currentColor","fillRule":"nonzero"},[React.createElement("path",{"d":"M13.235 2.55C12.46 1.937 10.105 0 7.025 0h-.05C3.896 0 1.542 1.937.768 2.548.144 3.036.007 3.552 0 3.892c-.009.473.185.894.576 1.245 1.076 1.01 3.352 2.737 6.372 2.766.015 0 .03.01.045.01 3.07 0 5.353-1.751 6.447-2.777.375-.336.569-.767.56-1.24-.01-.481-.281-.968-.765-1.346zm-1.7 1.85c-.752.706-2.54 1.961-4.54 1.97-2-.009-3.784-1.264-4.536-1.97-.14-.125-.237-.275-.233-.476.005-.286.306-.527.35-.562.92-.727 2.47-1.835 4.418-1.835 1.96 0 3.51 1.108 4.43 1.835.044.035.342.267.347.554.003.202-.096.359-.236.484z","key":0}),React.createElement("path",{"d":"M6.999 2.333c-.92.006-1.666.75-1.666 1.667S6.078 5.66 7 5.667A1.67 1.67 0 0 0 8.663 4 1.67 1.67 0 0 0 7 2.333h-.001z","key":1})]));
}

Eye.defaultProps = {"width":"14","height":"8","viewBox":"0 0 14 8"};

module.exports = Eye;

Eye.default = Eye;
